/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchProductMappingDto } from '../../models/patch-product-mapping-dto';
import { ProductMappingResponse } from '../../models/product-mapping-response';

export interface PatchProductMapping$Params {
  productMappingId: string;
      body: PatchProductMappingDto
}

export function patchProductMapping(http: HttpClient, rootUrl: string, params: PatchProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, patchProductMapping.PATH, 'patch');
  if (params) {
    rb.path('productMappingId', params.productMappingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingResponse>;
    })
  );
}

patchProductMapping.PATH = '/product-mapping/{productMappingId}';
